module.exports = __webpack_public_path__ + "media/images/icons/list-f5b7ce56270952188a9f505cc1c8a47b.svg";